// ==============================|| SHAPE ||============================== //

const shape = {
    borderRadiusSm: 4,
    borderRadius: 6,
    borderRadiusMd: 8,
    borderRadiusLg: 10,
    borderRadiusXl: 18
  };

  export default shape;
